import PolicyRuleItem from './PolicyRuleItem/PolicyRuleItem'
import PolicyRuleItemSkeleton from './PolicyRuleItemSkeleton/PolicyRuleItemSkeleton'
import SortableList from './SortableList/SortableList'
import SortableWrapper from './SortableWrapper/SortableWrapper'
import * as Styles from './styles'

const PolicyRuleItemList = ({
  rules,
  loading,
  onChangeEnabled,
  onEdit,
  onDuplicate,
  onDelete,
  disabled,
  dragging,
  onSortStart,
  onSortEnd,
}) => {
  if (loading) {
    return <PolicyRuleItemSkeleton />
  }

  return (
    <SortableList items={rules} onSortEnd={onSortEnd} onSortStart={onSortStart}>
      <Styles.Container>
        {rules?.map((rule, index) => (
          <SortableWrapper key={rule.id} id={rule.id} dragging={dragging}>
            <PolicyRuleItem
              rule={rule}
              index={index}
              onChangeEnabled={onChangeEnabled}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
              disabled={disabled}
            />
          </SortableWrapper>
        ))}
      </Styles.Container>
    </SortableList>
  )
}

export default PolicyRuleItemList
